import { createContext, useContext, RefObject } from 'react';

interface ChatScrollContextType {
  scrollToBottom: (smooth?: boolean) => void;
  /** Scroll to the bottom when the NEXT message commit lands, even if the
   *  user is scrolled up (explicit sends from inside the list, issue #89). */
  scrollToBottomOnNextMessage: () => void;
  messagesEndRef: RefObject<HTMLDivElement>;
  lastAgentMessageRef: RefObject<HTMLDivElement>;
}

const ChatScrollContext = createContext<ChatScrollContextType | null>(null);

export const useChatScrollContext = () => {
  const context = useContext(ChatScrollContext);
  if (!context) {
    throw new Error('useChatScroll must be used within ChatPanel');
  }
  return context;
};

export { ChatScrollContext };
